import {
  CERTIFICATION_ROUTE,
  DASHBOARD_ROUTE,
  DEVICE_TYPE_ROUTE,
  DEVICE_ROUTE,
  FIRMWARE_ROUTE,
  RESOURCE_ROUTE,
  ROOM_ROUTE,
  PROFILE_ROUTE
} from "config/route-consts";
import DashboardView from "views/DashboardView/DashboardView";

import { APP_USER_ROUTE } from "config/route-consts";
import AppUserView from "views/AppUserView/AppUserView";

import { HOME_CONTROLLER_ROUTE } from "config/route-consts";
import HomeControllerView from "views/HomeControllerView/HomeControllerView";

import { END_USER_ROUTE } from "config/route-consts";
import EndUserView from "views/EndUserView/EndUserView";

import { DORMITORY_ROUTE } from "config/route-consts";
import DormitoryView from "views/DormitoryView/DormitoryView";

import { SYSTEM_LOG_ROUTE, TICKET_ROUTE } from "config/route-consts";
import FirmwareView from "views/FirmwareView/FirmwareView";
import ResourceView from "views/ResourceView/ResourceView";
import TicketView from "views/TicketView/TicketView";
import SystemLogView from "views/SystemLogView/SystemLogView";

import CertificationView from "views/CertificationView/CertificationView";
import DeviceView from "views/DeviceView/DeviceView";
import DeviceTypeView from "views/DeviceTypeView/DeviceTypeView";
import RoomView from "views/RoomView/RoomView";
import ProfileView from "views/ProfileView/ProfileView";

export interface Route {
  path: string;
  component: () => JSX.Element;
}

export const routes: Route[] = [
  {
    path: DASHBOARD_ROUTE,
    component: DashboardView,
  },

  {
    path: APP_USER_ROUTE,
    component: AppUserView,
  },

  {
    path: END_USER_ROUTE,
    component: EndUserView,
  },
  {
    path: TICKET_ROUTE,
    component: TicketView,
  },
  {
    path: SYSTEM_LOG_ROUTE,
    component: SystemLogView,
  },

  {
    path: DORMITORY_ROUTE,
    component: DormitoryView,
  },
  {
    path: DEVICE_ROUTE,
    component: DeviceView,
  },
  {
    path: DEVICE_TYPE_ROUTE,
    component: DeviceTypeView,
  },
  {
    path: ROOM_ROUTE,
    component: RoomView,
  },
  {
    path: HOME_CONTROLLER_ROUTE,
    component: HomeControllerView,
  },

  {
    path: FIRMWARE_ROUTE,
    component: FirmwareView,
  },

  {
    path: CERTIFICATION_ROUTE,
    component: CertificationView,
  },

  {
    path: RESOURCE_ROUTE,
    component: ResourceView,
  },

  {
    path: PROFILE_ROUTE,
    component: ProfileView,
  },
];
